export class TransformRuleViewModel {
    id: number;
    name?: string;
    isEnabled: boolean;
    index: number;
    ruleName?: string;
    run: boolean;

    constructor(id: number, index: number, isEnabled: boolean, name?: string) {
      this.id = id;
      this.index = index + 1;
      this.isEnabled = isEnabled;
      this.name = name;
      this.ruleName = this.name;
      this.run = isEnabled;
      this.isEnabled = isEnabled;
    }

    /** How every transformer page names a rule: "Rule 2: Name", or "Rule 2" when it has no
     * name. `index` is the number shown in the rules table. The Transformer error analysis
     * (app/transformers/framework/diagnostics.py) uses the same wording. */
    static label(rule: { index: number; ruleName?: string; name?: string }): string {
      const name = (rule.ruleName ?? rule.name ?? '').trim();
      return name ? `Rule ${rule.index}: ${name}` : `Rule ${rule.index}`;
    }

    /** A validation message about one rule: the rule first, then the problem. */
    static ruleMessage(rule: { index: number; ruleName?: string; name?: string }, message: string): string {
      return `${TransformRuleViewModel.label(rule)}\n${message}`;
    }

    /** A validation message about several rules: the problem first, then one rule per line. */
    static rulesMessage(message: string, rules: { index: number; ruleName?: string; name?: string }[]): string {
      return [message, ...rules.map(rule => TransformRuleViewModel.label(rule))].join('\n');
    }

    /** The rules a Run or Save checks: only those switched on. A rule that is off is not run,
     * so it is never validated (the Transformer error analysis skips it too). */
    static enabledRules<T extends { run: boolean }>(rules: T[]): T[] {
      return (rules ?? []).filter(rule => rule.run !== false);
    }
}
